<div *ngIf="currentStep === 1">
  <app-initial-info [initialData]="pqqReferenceDates"></app-initial-info>
</div>
<!-- applicant side steps -->
<div *ngIf="currentStep === 2">
  <app-company-general-information
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-company-general-information>
</div>

<div *ngIf="currentStep === 3">
  <app-safty-environment-management
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-safty-environment-management>
</div>

<div *ngIf="currentStep === 4">
  <app-relevant-construction-expereince
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-relevant-construction-expereince>
</div>

<div *ngIf="currentStep === 5">
  <app-qms
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-qms>
</div>

<div *ngIf="currentStep === 6">
  <app-financial-information
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-financial-information>
</div>

<div *ngIf="currentStep === 7">
  <app-legal-compliance
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-legal-compliance>
</div>
<div *ngIf="currentStep === 8">
  <app-sustainbility
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-sustainbility>
</div>

<div *ngIf="currentStep === 9">
  <app-references
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-references>
</div>

<div *ngIf="currentStep === 10">
  <app-declaration
    [applicantData]="applicantData"
    [isEdit]="isEdit"
    (closeModalEvent)="handleCloseModal($event)"
    [isFetchApplicantData]="isFetchApplicantData"
  ></app-declaration>
</div>

<app-dialog-footer
  [step]="currentStep"
  (nextClicked)="onFooterNext()"
  (backClicked)="onFooterBack()"
></app-dialog-footer>
